var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export var initialValues = {
    isModalOpen: false,
    openInfoDrawer: function () { },
    close: function () { },
    modalProps: {
        content: null
    },
    setModalOpen: function () { },
    nestedDrawerOpen: false,
    setNestedDrawerOpen: function () { },
    openNestedDrawer: function () { },
    closeNestedDrawer: function () { }
};
export var InfoDrawerContext = createContext(initialValues);
export var InfoDrawerProvider = function (_a) {
    var children = _a.children;
    var location = useLocation();
    var _b = useState(false), nestedDrawerOpen = _b[0], setNestedDrawerOpen = _b[1];
    var _c = useState(false), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var _d = useState({
        content: null
    }), modalProps = _d[0], setModalProps = _d[1];
    // Close drawer when pathname changes (e.g., when a button navigates to a new page)
    useEffect(function () {
        if (isModalOpen) {
            setIsModalOpen(false);
            setNestedDrawerOpen(false);
            setModalProps({ content: null });
        }
    }, [location.pathname]);
    var openInfoDrawer = function (modalProps) {
        setIsModalOpen(true);
        setModalProps(modalProps);
    };
    var close = function () {
        setIsModalOpen(false);
        setNestedDrawerOpen(false);
        setModalProps({
            content: null
        });
    };
    var setModalOpen = function (open, modalProps) {
        setIsModalOpen(open);
        if (!open)
            setNestedDrawerOpen(false);
        setModalProps(modalProps || { content: null });
    };
    var openNestedDrawer = function (nestedDrawerContent) {
        setNestedDrawerOpen(true);
        setModalProps(function (prev) { return (__assign(__assign({}, prev), { nestedDrawerContent: nestedDrawerContent })); });
    };
    var closeNestedDrawer = function () {
        setNestedDrawerOpen(false);
        setModalProps(function (prev) { return (__assign(__assign({}, prev), { nestedDrawerContent: undefined })); });
    };
    // console.log('isModalOpen', isModalOpen);
    return (React.createElement(InfoDrawerContext.Provider, { value: { isModalOpen: isModalOpen, openInfoDrawer: openInfoDrawer, close: close, modalProps: modalProps, setModalOpen: setModalOpen, nestedDrawerOpen: nestedDrawerOpen, setNestedDrawerOpen: setNestedDrawerOpen, openNestedDrawer: openNestedDrawer, closeNestedDrawer: closeNestedDrawer } }, children));
};
export var useInfoDrawer = function () { return useContext(InfoDrawerContext); };
// HOC for class-based components
export var withInfoDrawer = function (Component) {
    var WrappedComponent = function (props) {
        var infoDrawerContext = useInfoDrawer();
        return React.createElement(Component, __assign({}, props, infoDrawerContext));
    };
    WrappedComponent.displayName = "withInfoDrawer(".concat(Component.displayName || Component.name, ")");
    return WrappedComponent;
};
